import Group from 'entities/group'
import Tag from 'entities/tag'
import { isEmpty } from 'lodash'

export default class RecruiterDestinationCandidate {
  constructor(id, name, number, group, tags) {
    this.id = parseInt(id, 10) || null
    this.name = name
    this.number = number
    this.group = group
    this.tags = tags
  }

  static fromJson(json) {
    return new RecruiterDestinationCandidate(
      json.id || null,
      json.name || null,
      json.number || null,
      Group.fromJson(json.group),
      !isEmpty(json.tags) ? json.tags.map(t => Tag.fromJson(t)) : []
    )
  }
}
